<template>
    <div>
        <p v-if="loading" class="text-center"><i>Loading...</i></p>
        <div v-html="brand.terms_and_conditions" class="term-text"></div>
        <div class="mt-3 d-flex flex-column align-items-center text-center login-links">
            <router-link :to="{name: 'login'}">
                <small class="d-flex align-items-center"><svg viewBox="0 0 512 512" class="back-arrow mr-1"><path d="m217.9 256 127.1-127c9.4-9.4 9.4-24.6 0-33.9-9.4-9.4-24.6-9.3-34 0l-144 143.9c-9.1 9.1-9.3 23.7-.7 33.1l144.6 144.9c4.7 4.7 10.9 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9z"/></svg> Back to Login</small>
            </router-link>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    export default {
        name: 'AuthTermsAndConditions',
        metaInfo: {
            title: 'Terms & conditions'
        },
        data () {
            return {
                brand: {
                    terms_and_conditions: null
                },
                loading: false
            }
        },
        mounted () {
            this.load_brand();
        },
        methods: {
            load_brand () {
                this.loading = true;
                axios.get(process.env.VUE_APP_API_URL + '/api/brand/')
                    .then(response => (
                        this.loading = false,
                        this.brand.terms_and_conditions = response.data['brand_terms_and_conditions']
                    ))
            }
        }
    }
</script>